import * as EducationActions from './actions';
import * as EducationConstants from './constants';
import * as D from './deps';
import EducationReducer from './reducer';
import * as EducationSelectors from './selectors';
import * as EducationUtils from './utils';

export default D.createDomainModule({
  name: 'education',
  components: {},
  constants: EducationConstants,
  utils: EducationUtils,
  actions: EducationActions,
  selectors: EducationSelectors,
  reducer: EducationReducer,
  persisted: true,
});
